<template>
  <div>
    <h3>Prescription</h3>
    <div class="ui styled" style="width: 100%">
      <div class="content">
        <abstractTable
          :columns="prescriptionColumns"
          :data="apiPrescriptionItems(prescription)"
          :classes="'ui very compact left aligned celled table'"
          v-if="prescription && prescription.prescription_items.length > 0"
        />
        <p v-else>No Prescription for this visit</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {
    abstractTable: require('@/components/abstract_components/AbstractTable')
      .default
  },
  props: {
    prescription: { type: Object, default: () => {} }
  },
  data() {
    this.prescriptionColumns = [
      {
        header: this.$t('medicine'),
        fieldName: 'medicine',
        show: true,
        width: '15%'
      },
      { header: this.$t('description'), fieldName: 'description', show: true }
    ];
    return {};
  },
  methods: {
    timeFormat(time) {
      return window.moment(time).format('LLLL');
    },
    apiPrescriptionItems(prescription) {
      let formalatedPrescriptionItems = [];

      window._.each(prescription.prescription_items, prescriptionItem => {
        formalatedPrescriptionItems.push({
          medicine: prescriptionItem.medicine_name,
          description: prescriptionItem.description
        });
      });

      return formalatedPrescriptionItems;
    }
  }
};
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/components/patients/patient_log_componenets/visit_history_components/Prescription.vue